<template>
    <b-button v-if="aguardandoAssinatura && podeAssinar" size="sm" :disabled="isLoading" variant="success"
        @click="$emit('assinar')">
        <b-spinner small v-if="isLoading" class="mr-2"></b-spinner>
        <font-awesome-icon v-else icon="file-signature" class="mr-2" />
        <span>Assinar</span>
    </b-button>
    <b-button v-else-if="!podeAssinar" size="sm" disabled variant="warning" v-b-tooltip.hover
        :title="textoRelatorioPendente">
        <font-awesome-icon icon="exclamation-triangle" class="mr-2" />
        <span>Ver relatórios</span>
    </b-button>
    <div v-else></div>
</template>
<script lang="ts">
import { AssinaturaDeContasMensal } from '@/types/entregas/pcm/assinatura-contas-mensais';
import { Component, Vue } from 'vue-property-decorator'
import pcmService from '@/services/entregas/pcmService';
import { PropType } from "vue";

const CompProps = Vue.extend({
    name: 'BtnAssinarPcm',
    props: {
        assinatura: {
            type: Object as PropType<AssinaturaDeContasMensal>,
            required: true
        },
        situacao: {
            type: String,
            required: true
        }
    },
    components: {},
})

@Component
export default class BtnAssinarPcm extends CompProps {
    isLoading = true
    podeAssinar = false
    textoRelatorioPendente = 'Você precisa visualizar todos os relatórios obrigatórios antes de assinar esta prestação!'

    get aguardandoAssinatura(): boolean {
        return this.situacao === 'A' || this.situacao === 'Aguardando Assinatura'
    }

    async created() {
        this.isLoading = true
        try {
            if (this.assinatura.CodSignatario !== 'G') {
                const response = await pcmService.validarVisualizacaoRelObrigatorios(this.assinatura.IdPrestacaoConta)
                this.podeAssinar = response
            } else {
                this.podeAssinar = true
            }
        } finally {
            this.isLoading = false
        }
    }
}

</script>